export default "__VITE_ASSET__7bbd1306__"